// @flow strict
import * as React from 'react'

const Facebook = () => (
  <symbol
    id="facebook"
    viewBox="0 0 9.6 18.5"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g>
      <path
        fill="#FFFFFF"
        d="M9.6,3.1H7.9c-1.4,0-1.6,0.7-1.6,1.6v2.1h3.3l-0.4,3.3H6.2v8.4H2.8v-8.4H0V6.8h2.8V4.3C2.8,1.5,4.6,0,7.1,0
		c1.2,0,2.2,0.1,2.5,0.1V3.1z"
      />
    </g>
  </symbol>
)

export default Facebook
